import { render, staticRenderFns } from "./ResultsTableView.vue?vue&type=template&id=08c11c2e&scoped=true"
import script from "./ResultsTableView.vue?vue&type=script&lang=js"
export * from "./ResultsTableView.vue?vue&type=script&lang=js"
import style0 from "./ResultsTableView.vue?vue&type=style&index=0&id=08c11c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c11c2e",
  null
  
)

export default component.exports